export default __webpack_public_path__ + "static/martinO-2b9419338588528e8d14342c3b8c33a4.png";